import React from "react";
import { CollectionStats } from "@/types/collection";

interface StatsSectionProps {
  stats: CollectionStats;
}

const StatsSection = ({ stats }: StatsSectionProps) => {
  return (
    <div className="flex justify-center gap-[10px] pt-[30px]">
      <div className="flex flex-col items-center justify-center">
        <span className="text-[24px] text-[#0099FE]">TOTAL</span>
        {stats.total === 0 ? (
          <div className="flex items-center justify-center pt-[14px] pb-[10px]">
            <img
              src="/assets/infinity.svg"
              alt="infinity"
              className="h-[24px]"
            />
          </div>
        ) : (
          <span className="text-[32px]">
            {Math.max(stats.mint_limit, stats.minted_nfts)}
          </span>
        )}
        <span className="text-[20px] text-[#0099FE]">
          {stats.is_sbt ? "SBT" : "NFT"}
        </span>
      </div>
      <div className="flex flex-col items-center justify-center">
        <span className="text-[24px] text-[#0099FE]">MINTED</span>
        <span className="text-[32px]">{stats.minted_nfts}</span>
        <span className="text-[20px] text-[#0099FE]">
          {stats.is_sbt ? "SBT" : "NFT"}
        </span>
      </div>
      <div className="flex flex-col items-center justify-center">
        <span className="text-[24px] text-[#0099FE]">OFFER</span>
        {!stats.mint_limit && stats.available === 0 ? (
          <div className="flex items-center justify-center pt-[14px] pb-[10px]">
            <img
              src="/assets/infinity.svg"
              alt="infinity"
              className="h-[24px]"
            />
          </div>
        ) : (
          <span className="text-[32px]">{stats.available}</span>
        )}
        <span className="text-[20px] text-[#0099FE]">
          {stats.is_sbt ? "SBT" : "NFT"}
        </span>
      </div>
    </div>
  );
};

export default StatsSection;
